import { Search } from "@mui/icons-material";
import { InputAdornment, TextField } from "@mui/material";
import { useState, useEffect, useRef } from "react";

export default function SearchBar({
  placeholder = "Search",
  onSearch,
  debounceDelay = 400,
  size = "small",
  className = "custom-input",
  sx = {},
  disabled = false,
  showSearchIcon = true,
  value = "",
  ...textFieldProps
}) {
  const [searchValue, setSearchValue] = useState(value || "");
  const timerRef = useRef(null);

  // Sync value from parent ONLY when it's explicitly cleared
  useEffect(() => {
    if (value === "" && searchValue !== "") {
      setSearchValue("");
    }
  }, [value]);

  const debouncedSearch = (val) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      if (onSearch) {
        onSearch(val);
      }
    }, debounceDelay);
  };

  const handleChange = (event) => {
    const newValue = event.target.value;
    setSearchValue(newValue);
    debouncedSearch(newValue);
  };

  return (
    <TextField
      id="search-input"
      size={size}
      placeholder={placeholder}
      type="search"
      className={className}
      sx={sx}
      value={searchValue}
      onChange={handleChange}
      disabled={disabled}
      InputProps={{
        startAdornment: showSearchIcon && (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
      {...textFieldProps}
    />
  );
}
